import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedPaymentModule } from '@arc/unified-payments-frontend/shared-payment';

import { sessionReducers } from './reducers/session.reducer';
import { SessionEffects } from './effects/session.effects';
import { SessionPaymentEffects } from './effects/session-payment.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedPaymentModule,
    StoreModule.forFeature('btpay session', sessionReducers),
    EffectsModule.forFeature([SessionEffects, SessionPaymentEffects]),
  ],
})
export class SessionStoreModule {}
